import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=de5a652a&"
import script from "./Classroom.vue?vue&type=script&lang=js&"
export * from "./Classroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports